<template>
    <PageLayout ref="PageLayout" page-type="about">
        <div class="article-main">
            <div
                v-for="item in articleList"
                :key="item.key"
                v-loading="item.loading"
            >
                <div class="article-title">
                    <h2>{{ item.title }}</h2>
                </div>
                <div class="article-content" v-html="item.content"></div>
            </div>

            <!-- <PrismCode language="js" :code="jsCode" />
            <PrismCode language="css" :code="cssCode" /> -->
        </div>
    </PageLayout>
</template>

<script>
import PageLayout from '/src/layout/pageLayout.vue';
// import PrismCode from '/src/components/PrismCode/index.vue';

import { ApiGetArticle } from '/src/api/common';

// const tmpJsCode = `let msg = "hello world"
// console.log(msg)`;

// const tmpCssCode = `.article-title {
//     margin-bottom: 35px;

//     font-size: 18px;
//     line-height: 1.2;
//     color: #535353;
//     text-align: center;

//     h2 {
//         font-size: inherit;
//         color: inherit;
//         font-weight: normal;
//     }
// }`;

export default {
    name: 'ArticleHomePage',
    components: {
        PageLayout,
        // PrismCode,
    },
    data() {
        return {
            loading: false,

            articleCfg: {
                about: [
                    {
                        title: '公司介绍',
                        key: 'about',
                        loading: false,
                        content: '',
                    },
                    {
                        title: '联系我们',
                        key: 'contact',
                        loading: false,
                        content: '',
                    },
                ],
                service: [
                    {
                        title: '用户服务协议',
                        key: 'service',
                        loading: false,
                        content: '',
                    },
                ],
                privacy: [
                    {
                        title: '隐私协议',
                        key: 'privacy',
                        loading: false,
                        content: '',
                    },
                ],
            },

            articleList: [],

            // jsCode: tmpJsCode,
            // cssCode: tmpCssCode,
        };
    },
    created() {},
    mounted() {
        const { meta } = this.$route;

        this.articleList = this.articleCfg[meta.page];

        if (!this.articleList) {
            this.$router.push('/error/404');

            return false;
        }

        this.articleList.forEach(item => {
            this.handleGetDetail(item);
        });
    },
    methods: {
        handleGetDetail(item) {
            if (item.loading) {
                return false;
            }

            item.loading = true;

            ApiGetArticle(item.key)
                .then(data => {
                    item.loading = false;

                    item.content = data;
                })
                .catch(() => {
                    item.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped></style>
